import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'

export function RequireAuth() {
  const { isReady, isLoggedIn } = useAuth()
  const location = useLocation()

  if (!isReady) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-zinc-50 text-zinc-600 dark:bg-zinc-950 dark:text-zinc-400">
        Φόρτωση…
      </div>
    )
  }

  if (!isLoggedIn) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    )
  }

  return <Outlet />
}
